import * as React from 'react'
import { I18nService } from "../../../../services/utils/i18n.service"
import { StoreProps } from '../../../../services/stores/casting.store'
import PostalAddressInput from '../../../shared/postal-address-input.component'
import { Input } from '../casting-styled.component'

const i18nScoped = new I18nService(require('./casting-lodging-new.component.yml'))

export default function CastingLodgingNewComponent ({ store, data: { lodging, countries } }: StoreProps) {
  if (!lodging || ('id' in lodging)) return null

  return <>
    <Input
      id='js-test-lodging-name'
      style={{ marginBottom: 0 }}
      type='text'
      placeholder={ i18nScoped.t('name') }
      value={ lodging.name }
      onChange={ e => store.set({ lodging: { ...lodging, name: e.target.value } }) } />

    <div style={{ fontSize: '80%', marginBottom: '1.25em' }}>{ i18nScoped.t('name_tooltip') }</div>

    <div style={{ marginBottom: '1.25em' }}>
      <PostalAddressInput
        name="lodging_address"
        prefix=""
        hasAdditional
        address={ lodging.address_attributes }
        countries={ countries }
        onChange={ address => store.set({ lodging: { ...lodging, address_attributes: address as typeof lodging.address_attributes } }) } />
    </div>
  </>
}
